export const RESET_OFFICE = "RESET_OFFICE"

export const QUERY_OFFICES = "QUERY_OFFICES"
export const QUERY_OFFICES_SUCCESS = "QUERY_OFFICES_SUCCESS"
export const QUERY_OFFICES_FAILED = "QUERY_OFFICES_FAILED"

export const GET_OFFICES = "GET_OFFICES"
export const GET_OFFICES_SUCCESS = "GET_OFFICES_SUCCESS"
export const GET_OFFICES_FAILED = "GET_OFFICES_FAILED"

export const GET_OFFICE = "GET_OFFICE"
export const GET_OFFICE_SUCCESS = "GET_OFFICE_SUCCESS"
export const GET_OFFICE_FAILED = "GET_OFFICE_FAILED"

export const REGISTER_OFFICE = "REGISTER_OFFICE"
export const REGISTER_OFFICE_SUCCESS = "REGISTER_OFFICE_SUCCESS"
export const REGISTER_OFFICE_FAILED = "REGISTER_OFFICE_FAILED"

export const UPDATE_OFFICE = "UPDATE_OFFICE"
export const UPDATE_OFFICE_SUCCESS = "UPDATE_OFFICE_SUCCESS"
export const UPDATE_OFFICE_FAILED = "UPDATE_OFFICE_FAILED"

export const DELETE_OFFICE = "DELETE_OFFICE"
export const DELETE_OFFICE_SUCCESS = "DELETE_OFFICE_SUCCESS"
export const DELETE_OFFICE_FAILED = "DELETE_OFFICE_FAILED"

export const CONFIRM_OFFICE = "CONFIRM_OFFICE";
export const CONFIRM_OFFICE_SUCCESS = "CONFIRM_OFFICE_SUCCESS"
export const CONFIRM_OFFICE_FAILED = "CONFIRM_OFFICE_FAILED"

export const PRINT_OFFICE_REPORT = "PRINT_OFFICE_REPORT";
export const PRINT_OFFICE_REPORT_SUCCESS = "PRINT_OFFICE_REPORT_SUCCESS"
export const PRINT_OFFICE_REPORT_FAILED = "PRINT_OFFICE_REPORT_FAILED"
export const PRINT_OFFICE_REPORT_RESET = "PRINT_OFFICE_REPORT_RESET"

export const ADD_ORDER_OFFICE = "ADD_ORDER_OFFICE"
export const ADD_ORDER_OFFICE_SUCCESS = "ADD_ORDER_OFFICE_SUCCESS"
export const ADD_ORDER_OFFICE_FAILED = "ADD_ORDER_OFFICE_FAILED"

export const DELETE_ORDER_OFFICE = "DELETE_ORDER_OFFICE"
export const DELETE_ORDER_OFFICE_SUCCESS = "DELETE_ORDER_OFFICE_SUCCESS"
export const DELETE_ORDER_OFFICE_FAILED = "DELETE_ORDER_OFFICE_FAILED"

export const IMPORT_FILE = "IMPORT_FILE"
export const IMPORT_FILE_SUCCESS = "IMPORT_FILE_SUCCESS"
export const IMPORT_FILE_FAILED = "IMPORT_FILE_FAILED"
export const IMPORT_FILE_RESET = "IMPORT_FILE_RESET"
